<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button [disabled]=vb.disabled data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Ticket</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Ticket Verification - (Step 3 of 3)
    </ion-list-header>

    <ion-list lines="none">
        <ion-item data-test="ticketContents">

            <ion-label class="ion-text-wrap">
                <strong id="passengerName">Passenger: {{vm.ticket.passengerName}}</strong><br />
                <span id="numPassengers">Number of Passengers: {{vm.ticket.numPassengers}}</span><br />
                <span id="cellPhone">Cell Phone: {{vm.ticket.cellPhone}}</span><br />
                <span id="note">Note: {{vm.ticket.note}}</span><br />
                <span id="priority">Priority: {{vm.isUrgencyStr}}</span><br />
                <span id="origin">Origin: {{vm.directionStr}}</span><br />
                <br />

                @if (vm.ticket.fromDealership) {
  <div>
                    <strong>Dropoff Location</strong><br />
                    <span id="dropoffLocation">{{vm.ticket.dropoff.locationName}}</span><br /><br />

                    <strong>Dropoff Address</strong><br />
                    <span id="dropoffAddress">{{vm.ticket.dropoff.address.fullAddress}}</span><br /><br />
                </div>
}

                @if (!vm.ticket.fromDealership) {
  <div>
                    <strong>Pickup Location</strong><br />
                    <span id="pickupLocation">{{vm.ticket.pickup.locationName}}</span><br /><br />

                    <strong>Pickup Address</strong><br />
                    <span id="pickupAddress">{{vm.ticket.pickup.address.fullAddress}}</span><br /><br />
                </div>
}

                <br />
                @if (vm.addressVerified) {
  <div>
                    <span class="line1 infoMsg">{{vm.addressVerifiedMsg}}</span><br />
                </div>
}
            </ion-label>
        </ion-item>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        @if (showSetUserButton()) {
  <ion-button color="primary" expand="full" (click)="onToggleServiceAdvisor()"
            data-test="toggleServiceAdvisor">
            Service Advisor: {{vm.ticket.serviceAdvisor}}
        </ion-button>
}
        <ion-button color="primary" [disabled]=vb.disabled expand="full" (click)="onSaveClick()" data-test="saveTicket">
            Save Ticket
        </ion-button>

        <!-- <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-button color="primary" expand="full" (click)="onToggleServiceAdvisor()" data-test="toggleServiceAdvisor">
                        Service Advisor: {{vm.ticket.serviceAdvisor}}
                    </ion-button>            
                </ion-col>
                <ion-col>
                    <ion-button color="primary" [disabled]=vb.disabled expand="full" (click)="onSaveClick()" data-test="saveTicket">
                        Save Ticket
                    </ion-button>            
                </ion-col>
            </ion-row>
        </ion-grid> -->
    </ion-toolbar>
</ion-footer>